module.exports = __webpack_public_path__ + "static/media/ahri-icon.7f8193ca.png";